import * as React from 'react';

import * as styles from './ChatListWrapperLayout.css';

interface IChatListWrapperLayoutProps {
  children: React.ReactNode;
}

export const ChatListWrapperLayout: React.FC<IChatListWrapperLayoutProps> = ({ children }) => {
  return <div className={styles['container']}>{children}</div>;
};
